/**
 * Módulo: Columns Slider
 * Grid no desktop; Swiper com dots e setas no mobile.
 *
 * Usa matchMedia + destroy(true, true) para alternar entre os modos.
 * Ao destruir o Swiper, todos os inline styles que ele adicionou são removidos
 * e o CSS flex-layout do desktop assume sem conflito.
 */

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const BP = { sm: 575.98, md: 767.98, lg: 991.98 };

export function initColumnsSlider() {
  document.querySelectorAll('.col-slider').forEach(wrapper => {
    const swiperEl = wrapper.querySelector('.col-slider__swiper');
    if (!swiperEl) return;

    if (wrapper.classList.contains('col-slider--break-none')) return;

    let desktopPx = BP.md;
    if (wrapper.classList.contains('col-slider--break-sm')) desktopPx = BP.sm;
    else if (wrapper.classList.contains('col-slider--break-lg')) desktopPx = BP.lg;

    const mq = window.matchMedia(`(max-width: ${desktopPx - 1}px)`);

    function initSwiper() {
      if (swiperEl.swiper) return;

      const prevEl       = wrapper.querySelector('.col-slider__btn--prev');
      const nextEl       = wrapper.querySelector('.col-slider__btn--next');
      const paginationEl = wrapper.querySelector('.col-slider__pagination');
      const slideCount   = swiperEl.querySelectorAll('.swiper-slide').length;
      const spvRaw       = wrapper.dataset.slidesPerView;
      const slidesPerView = spvRaw ? parseFloat(spvRaw) : 1;
      const hasPeek      = slidesPerView !== Math.floor(slidesPerView) || slidesPerView > 1;

      // Calcula spaceBetween a partir do CSS custom property
      const styles = getComputedStyle(wrapper);
      let gapRaw = styles.getPropertyValue('--cols-gap-mobile').trim();
      if (!gapRaw) {
        gapRaw = styles.getPropertyValue('--cols-gap').trim();
      }
      
      let spaceBetween = 0;
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      if (gapRaw.endsWith('rem')) {
        spaceBetween = parseFloat(gapRaw) * rootFontSize;
      } else if (gapRaw.endsWith('px')) {
        spaceBetween = parseFloat(gapRaw);
      } else {
        spaceBetween = 12;
      }

      new Swiper(swiperEl, {
        modules: [Navigation, Pagination],
        slidesPerView: hasPeek ? 'auto' : slidesPerView,
        spaceBetween,
        loop: slideCount > 1 && !hasPeek,
        navigation: { prevEl, nextEl },
        pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
        a11y: {
          prevSlideMessage: 'Item anterior',
          nextSlideMessage: 'Próximo item',
        },
      });
    }

    function destroySwiper() {
      if (swiperEl.swiper) {
        // cleanStyles: true — remove todos os inline styles adicionados pelo Swiper
        swiperEl.swiper.destroy(true, true);
      }
    }

    if (mq.matches) {
      initSwiper();
    }

    mq.addEventListener('change', e => {
      if (e.matches) {
        initSwiper();
      } else {
        destroySwiper();
      }
    });
  });
}
